import { RecursiveObject } from '@chakra-ui/theme'

export const shadows: RecursiveObject<string> = {
  card: '0px 1px 5px #000B2633',
}
